import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogSurface,
  DialogTitle,
  makeStyles,
} from "@fluentui/react-components";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { useState } from "react";
import moment from "moment";
import ASCButton from "../../../components/Button";
import DynamicDatePicker from "../../../components/ControlledDatePicker/dynamicDatepicker";

const useStyles = makeStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  widthcontent: {
    width: "520px",
  },
  btnWrapper: {
    margin: "10px 0",
  },
  dialogTitle: {
    fontSize: "16px",
    fontWeight: 600,
    textAlign: "left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

interface SavePopupProps {
  confirmationStopDistributionPopup: boolean;
  setStopDistributionConfirmationPopup: any;
  onSave: any;
  postStopDistributionLoading: boolean;
}

const ConfirmStopDistributionPopup = (props: SavePopupProps) => {
  const styles = useStyles();
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

  const onSelectDate = (date: Date | null | undefined) => {
    setSelectedDate(date ?? null);
  };

  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(date).format("DD-MM-YYYY");
  };

  const handleSave = async () => {
    const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
    props.onSave({
      stop_distribution_date: formattedDate,
    });
  };

  return (
    <Dialog open={props.confirmationStopDistributionPopup}>
      <DialogSurface className={styles.widthcontent}>
        <DialogTitle className={styles.dialogTitle}>
          Stop Distribution Confirmation
        </DialogTitle>

        <DialogBody className={styles.content}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "8px",
            }}
          >
            <label>Stop Description Date:</label>
            <DynamicDatePicker
              name="selected_date"
              border
              label={null}
              required={false}
              disabled={false}
              formik={{
                values: {
                  selected_date: selectedDate,
                },
                setFieldValue: (_name: string, value: Date | null) => {
                  onSelectDate(value);
                },
                setFieldTouched: () => {},
                setFieldError: () => {},
                errors: {},
                touched: {},
              }}
            />
          </div>
        </DialogBody>

        <DialogActions className={styles.btnWrapper}>
          <ASCButton
            shape="rounded"
            className="asc-button-primary"
            appearance="primary"
            onClick={handleSave}
            disabled={props?.postStopDistributionLoading}
            label={
              props?.postStopDistributionLoading ? "Stopping..." : "Confirm"
            }
          />

          <Button
            appearance="secondary"
            onClick={() => {
              props.setStopDistributionConfirmationPopup(false);
              //   setSelectedDate(new Date());
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
};

export default ConfirmStopDistributionPopup;
